import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  getDoc,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";

const informationsModule = {
  namespaced: true,
  state: {
    informationsList: [],
    updateInformation: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getInformations: (state) => state.informationsList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Informations
    setInformations: (state, payload) => {
      state.informationsList = payload;
    },
    // Add Information
    addInformation: (state, payload) => {
      if (state.informationsList.length > 0)
        state.informationsList.unshift(payload);
      else state.informationsList = [payload];
    },
    // get Review by id
    getInformationById: (state, payload) => {
      state.updateInformation = state.informationsList.find(
        (information) => information.information_id == payload
      );
    },
    // Update Information
    updateInformation: (state, payload) => {
      const findIndex = state.informationsList.findIndex(
        (information) => information.information_id == payload.information_id
      );
      state.informationsList[findIndex] = payload;
    },
    // Delete Information
    deleteInformation: (state, payload) => {
      let filtered = state.informationsList.filter(function (value) {
        return value.information_id != payload;
      });
      state.informationsList = filtered;
    },
  },
  actions: {
    // Get All Informations
    async fetchInformations({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const informationsList = await getDocs(
        query(collection(db, "Informations"), orderBy("created_date", "desc"))
      );
      let informationArray = [];
      if (!informationsList.empty) {
        informationsList.forEach((doc) => {
          informationArray.push({ ...doc.data(), information_id: doc.id });
        });
      } else {
        console.log("No Informations found");
        informationArray = false;
      }
      commit("setInformations", informationArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return informationsList;
    },
    // Add Information
    async addInformation({ commit }, payload) {
      const documentReference = doc(collection(db, "Informations"));
      const information = {
        ...payload,
        information_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, information);
      commit("addInformation", information);
    },
    // Get Information by id
    async getInformationById({ commit }, payload) {
      let information = await getDoc(doc(db, "Informations", payload));
      commit("getInformationById", information);
      return information.data();
    },
    // Update Information
    async updateInformation({ commit }, payload) {
      updateDoc(doc(db, "Informations", payload.information_id), payload);
      commit("updateInformation", payload);
    },
    // Delete Information
    async deleteInformation({ commit }, payload) {
      deleteDoc(doc(db, "Informations", payload));
      commit("deleteInformation", payload);
    },
  },
};

export default informationsModule;
